import styled from 'styled-components';

// Custom styled component for fixed ContentHeader
interface FixedHeaderContentProps {
    isRoleAssumptionStarted?: boolean;
}

export const FixedHeaderContent = styled.div<FixedHeaderContentProps>`
    padding-top: ${({ isRoleAssumptionStarted }) => (isRoleAssumptionStarted ? '0px' : '4px')};
    position: sticky;
    top: 38px;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: ${({ theme }) => theme.tokens.BaseColorWhite};
    width: 100%;
`;
